<template>
    <hb-modal v-model="dialog" show-help-link size="large" title="Manage Ring Groups" :scrollable="false" @close="closeWindow">
        <template v-slot:content>
            <div class="modal-sub-header my-4 mx-4">
                <span class="hb-text-night hb-font-body-medium">{{ selectedUser?.full_name }}</span>
                <!-- <span class="hb-text-light hb-font-body">Manage this user's ring groups by property.</span> -->
            </div>
            <v-divider class="mt-4"></v-divider>
            <div class="panels-container">
                <v-expansion-panels multiple v-model="expandedPanels" class="px-3 pb-2">
                    <hb-expansion-panel
                    v-for="(property, index) in ivrData"
                    :key="property.property_id"
                    >
                        <template v-slot:title>
                            {{ property.number }} - {{ property.name }}
                        </template>
                        <template v-slot:content>
                            <div v-for="(flow, idx) in property.options || []" :key="idx" class="ring-group-row px-3 pt-2">
                                <div class="ring-group-label"> {{ flow.id ? flow.id + ' - ' : '' }} {{ flow.title || flow.action_name }}</div>
                                <hb-radio-group
                                    v-model="flow.radioSelection"
                                    class="ring-group-radios"
                                    row
                                >
                                    <HbRadio label="Primary" value="primary" />
                                    <HbRadio label="Secondary" value="secondary" />
                                </hb-radio-group>
                            </div>
                        </template>
                    </hb-expansion-panel>
                </v-expansion-panels>
            </div>
            
        </template>
        <template v-slot:actions>
            <hb-btn :loading="saving" :disabled="saving" color="primary" @click="save">Save</hb-btn>
      </template>
    </hb-modal>
</template>

<script>
    import api from '../../../assets/api.js';
    import { notificationMixin } from  '../../../mixins/notificationMixin.js';

    import { mapGetters } from 'vuex';
    export default {
        name:'ManageRingingGroups',
        mixins: [ notificationMixin ],
        data() {
            return{
                radioGroupSantaAnaNewLead: 'primary',
                radioGroupSantaAnaExistingTenant: 'primary',
                expandedPanels: [],
                ivrData: [],
                saving: false,
            }
         },
        props: {
            value: {
                type: Boolean,
                required: true
            },
            selectedUser: {
               type: Object,
                default: () => ({})
            },
         
        },
        computed: {
            dialog: {
                get () {
                    return this.value
                },
                set (value) {
                    this.$emit('input', value)
                }
            },
            ...mapGetters({
                properties: "propertiesStore/filtered",
                charmSubscribedProperties: "charmSubscriptionStore/charmSubscribedProperties",
                agentgroups:'charmSubscriptionStore/agentgroups',
                agentGroupsIvrFlow:'charmSubscriptionStore/agentGroupsIvrFlow',
                
            }),
        },
        methods: {
            async save(){
                this.saving = true;
                try {
                    const agentId   = this.selectedUser.user_id
                    const data = await this.buildRingGroupPayload(agentId)
                    await api.post(this, api.RING_GROUPS + `/${agentId}`,{data}).then((result)=>{
                        this.showMessageNotification({ type: 'success', description: "Ring groups saved successfully" });
                        this.$emit('input', false);
                    }).catch((err)=>{
                        console.log(err)
                        this.showMessageNotification({ type: 'error', description: "Save failed" });
                    })
                } catch (err) {
                    console.error("Save failed", err);
                    this.showMessageNotification({ type: 'error', description: "Save failed" });
                } finally {
                    this.saving = false;
                }
                
            },
            async buildRingGroupPayload (agentId) {
                const lookup = new Map(
                    (this.agentgroups || []).map(g => [`${g.property_id}:${g.at_option}`, g])
                )

                const rows = []

                this.ivrData.forEach(flow => {
                    const propertyId = flow.property_id;

                    (flow.options || []).forEach(opt => {
                        const key     = `${propertyId}:${opt.id}`
                        const current = lookup.get(key)

                        const row = {
                            agent_id: agentId,
                            property_id: propertyId,
                            at_option: opt.id,
                            secondary: opt.radioSelection === 'secondary' ? 1 : 0,
                            ring_action_id: opt?.action_id || null,
                            uniqueId: opt?.uniqueId || null
                        }
                        if (current?.id) {
                            row.id = current.id           
                        }
                        rows.push(row)
                    })
                })
                return rows
            },
            closeWindow() {
                this.$emit('input', false);
            }
        },
        watch: {
            agentGroupsIvrFlow: {
                immediate: true,
                handler(flows) {
                if (!this.properties.length) return;

                 const groupLookup = new Map();

                (this.agentgroups || []).forEach(g => {
                    const key = `${g.property_id}:${g.at_option}`;
                    if (!groupLookup.has(key) || g.active === 1) {
                    groupLookup.set(key, g);
                    }
                })

                const merged = (flows || []).map(flow => {
                    const prop = this.properties.find(p => p.gds_id === flow.facility_id) || {};

                    const options = (flow.options || []).map(opt => {
                        const key = `${prop.id}:${opt.id}`;
                        const group = groupLookup.get(key);
                        const radioSelection = group ? (group.secondary ? 'secondary' : 'primary') : 'primary';

                        return {
                            ...opt,
                            radioSelection
                        };
                    });

                    return {
                        ...flow,
                        name: prop.name || null,
                        number: prop.number || null,
                        property_id: prop.id || null,
                        options
                    };
                });
                this.ivrData = merged
                this.expandedPanels = merged.map((_, i) => i)
                }
            }
        }

    }
</script>

<style lang="scss" scoped>
.modal-sub-header{
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.ring-group-row {
    display: flex;
    justify-content: space-between;
}
.ring-group-label {
    width: 160px;
    font-size: 14px;
}
.ring-group-radios {
    display: flex;
    gap: 24px;
}
.panels-container{
    max-height: 60vh;
    overflow: auto;
}
</style>